import { Modal, ModalContent } from 'ui/components/ModalV2/Modal';
import React, { useState } from 'react';
import { useTranslation } from '@whoop/i18n/lang/client';
import { Button, cltw } from 'ui';
import LoadingButton from 'ui/components/ButtonV2/LoadingButton';
import { Separator } from 'ui/components/Separator/Separator';
export const ONE_TRUST_BANNER_ID = 'onetrust-banner-sdk';
export const ONE_TRUST_STYLE_ID = 'onetrust-style';
export default function AdvancedLabsModal({
  referrer,
  isOneTrustBannerVisible,
  onStartWithFreeTrial,
  isAddingToCart
}: {
  referrer: string;
  isOneTrustBannerVisible: boolean;
  onStartWithFreeTrial: () => void;
  isAddingToCart: boolean;
}) {
  const {
    t
  } = useTranslation('joinLandingPage');
  const [isOpen, setIsOpen] = useState(true);
  return <Modal onOpenChange={setIsOpen} open={isOpen} data-sentry-element="Modal" data-sentry-component="AdvancedLabsModal" data-sentry-source-file="AdvancedLabsModal.tsx">
      <ModalContent className={cltw('z-modal xs:w-96 flex w-full flex-col items-center gap-4 rounded-2xl border-0 px-8 pb-12 text-center text-white', 'bg-green-radial', isOneTrustBannerVisible ? 'top-[15%] translate-y-[-15%] sm:top-[50%] sm:translate-y-[-50%]' : '')} closeButtonPathStroke='white' data-sentry-element="ModalContent" data-sentry-source-file="AdvancedLabsModal.tsx">
        <p className='w-full text-3xl font-semibold'>
          {t('joinLandingPage:advancedLabsModal:title')}
        </p>
        <p className='w-full text-base'>
          {t('joinLandingPage:advancedLabsModal:description', {
          referrer
        })}
        </p>
        <div className='flex w-full flex-col items-center gap-4 px-2 text-center'>
          <p className='text-base'>
            {t('joinLandingPage:advancedLabsModal:membershipRequired')}
          </p>
          <LoadingButton className='text-xs' variant='transparentWithBorderBright' onClick={onStartWithFreeTrial} disabled={isAddingToCart} data-sentry-element="LoadingButton" data-sentry-source-file="AdvancedLabsModal.tsx">
            {t('joinLandingPage:advancedLabsModal:startWithTrial')}
          </LoadingButton>
          <Button className='p-0 text-xs' variant='underline' onClick={() => setIsOpen(false)} disabled={isAddingToCart} data-sentry-element="Button" data-sentry-source-file="AdvancedLabsModal.tsx">
            {t('joinLandingPage:advancedLabsModal:chooseAMembership')}
          </Button>
          <div className='w-full py-2'>
            <Separator className='bg-gray-30' data-sentry-element="Separator" data-sentry-source-file="AdvancedLabsModal.tsx" />
          </div>
          <div className='text-gray-30 flex flex-col gap-0 text-base'>
            <p>{t('joinLandingPage:advancedLabsModal:alreadyAMember')}</p>
            <p>{t('joinLandingPage:advancedLabsModal:openInApp')}</p>
          </div>
        </div>
      </ModalContent>
    </Modal>;
}